
export const getFilteredMatches = (matches: any[], team: string, type: 'wins' | 'draws' | 'losses') => {
  // First filter the matches
  const filteredMatches = matches.filter(match => {
    const isHomeTeam = match.HomeTeam === team;
    const isAwayTeam = match.AwayTeam === team;

    // Only include matches where the team participated
    if (!isHomeTeam && !isAwayTeam) return false;

    // Use FTR (Full Time Result) for all conditions
    switch (type) {
      case 'wins':
        return (isHomeTeam && match.FTR === 'H') || (isAwayTeam && match.FTR === 'A');
      case 'draws':
        return (isHomeTeam || isAwayTeam) && match.FTR === 'D';
      case 'losses':
        return (isHomeTeam && match.FTR === 'A') || (isAwayTeam && match.FTR === 'H');
      default:
        return false;
    }
  });

  // Sort matches by date in descending order (newest first)
  // Direct string comparison on whatever date format is in the data
  const sortedMatches = filteredMatches.sort((a, b) => {
    try {
      // Simple string comparison, let the dates be displayed exactly as they are
      return b.Date.localeCompare(a.Date);
    } catch (error) {
      console.error('Error sorting dates:', error, 'Dates:', a.Date, b.Date);
      return 0;
    }
  });

  return sortedMatches;
};
